import deResources from "./de/index-studio";
import enResources from "./en/index-studio";
import hiResources from "./hi/index-studio";
import ptResources from "./pt/index-studio";

export type * from "./locales-studio.types";

export const resources = {
  en: enResources,
  pt: ptResources,
  de: deResources,
  hi: hiResources,
};
